export default {
  price: {
    presence: { allowEmpty: false }
  },
  credit: {
    presence: { allowEmpty: false }
  }
};
